import React, { FC, Key } from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import "./styles/reduction.scss";
import {
  ThemeProvider,
  createTheme,
  Button,
  IconButton,
} from "@material-ui/core";
import { primary, secondary, success, error } from "./styles/theme";
import Layout from "./components/Layout/Layout";
import CircularProgress from "@material-ui/core/CircularProgress";
import GenerateRoute from "./config/RouteUtil";
import { ROUTE_PAGE } from "config/RoutePage";
import AuthForm from "Page/Auth/Auth";
import { SnackbarProvider, useSnackbar } from "notistack";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import es from "date-fns/locale/es";
import CloseIcon from "@material-ui/icons/Close";

const theme = createTheme({
  palette: {
    primary: primary,
    secondary: secondary,
    success: success,
    error: error,
  },
});

interface CloseSnackbarProps {
  key: Key;
}
const CloseButton = () => {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton
      aria-label="Close notification"
      color="inherit"
      onClick={() => closeSnackbar()}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};

export default function App(props: any) {
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
        <SnackbarProvider action={() => <CloseButton/>}>
          <BrowserRouter>
            <Switch>
              <Route exact path={ROUTE_PAGE.AUTH.LOGIN}>
                <AuthForm />
              </Route>
              <Route exact path={ROUTE_PAGE.ERROR_PAGE[404]}>
                <div>not found</div>
              </Route>

              <Layout>
                <React.Suspense fallback={<CircularProgress />}>
                  <GenerateRoute />
                </React.Suspense>
              </Layout>

              <Redirect to={ROUTE_PAGE.ERROR_PAGE[404]} />
            </Switch>
          </BrowserRouter>
        </SnackbarProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}
